export var TypeIcon;
(function (TypeIcon) {
    TypeIcon["Blanks"] = "icon-Blanks";
    TypeIcon["Sort"] = "icon-Sort";
    TypeIcon["Poll"] = "icon-Poll";
    TypeIcon["Grid"] = "icon-Grid";
    TypeIcon["Prompt"] = "icon-Prompt";
    TypeIcon["Multimedia"] = "icon-Multimedia";
    TypeIcon["ImageReview"] = "icon-Image_review";
    TypeIcon["VideoReview"] = "icon-Video_review";
    TypeIcon["PLAIN_TEXT"] = "icon-Text";
    TypeIcon["CHOICE"] = "icon-Poll_2";
    TypeIcon["PHOTOS"] = "icon-Photos";
    TypeIcon["SCALE"] = "icon-Scale";
    TypeIcon["SCALE_ALLOCATION"] = "icon-Scale_2";
})(TypeIcon || (TypeIcon = {}));
